import debounce from 'lodash/fp/debounce.js';
import { change, formValueSelector } from 'redux-form';
import { REDUX_FORM_CHANGE } from '@hbrisk/sp3-risk-model-support/actions/types.js';
import selectHasRun from '@hbrisk/sp3-risk-model-support/models/form/selectHasRun.js';
import {
  CITY,
  COUNTRY,
  LAT,
  LNG,
  STATE,
  STREET,
  ZIP,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { geocode } from '#actions/models/geocode.js';
import googleGeocodeUrl from '#support/models/geocoding/googleGeocodeUrl.js';
import format from '#support/models/formatCoordinateValue.js';
import { currentModelId } from '#selectors/entities/models.js';

const setCoordinateFieldValuesBase = (store, form) => {
  const { dispatch, getState } = store;
  const state = getState();
  const {
    [STREET]: street,
    [CITY]: city,
    [STATE]: st,
    [COUNTRY]: country,
  } = formValueSelector(form)(state, STREET, CITY, STATE, COUNTRY);
  if (street && city && st && country) {
    // Captured here rather than at schedule time: the debounce is trailing-edge, so the last
    // call's arguments win and there is no schedule-time hook to thread an id through.
    const modelId = currentModelId(state);
    dispatch(geocode(googleGeocodeUrl(street, city, st, country))).then(({ payload }) => {
      // Re-reading selectHasRun here would fall back to entities.models.current, which is nulled
      // on model-page unmount — so it fails open. Comparing the id keeps the result on the model
      // it was computed for.
      if (payload && currentModelId(store.getState()) === modelId) {
        const { [LAT]: lat, [LNG]: lng } = payload;
        dispatch(change(form, LAT, format(lat)));
        dispatch(change(form, LNG, format(lng)));
      }
    });
  }
};

const setCoordinateFieldValues = debounce(500, setCoordinateFieldValuesBase);

const geocodeOnAddressChange = ({ store, action, form }) => {
  const { type } = action;

  if (type === REDUX_FORM_CHANGE) {
    const {
      meta: { field, form: actionForm },
    } = action;
    if (actionForm === form && [STREET, CITY, STATE, ZIP, COUNTRY].includes(field)) {
      // Coordinates are frozen once a run exists. cancel() as well as returning, because the
      // debounced function is a module-level singleton shared by all three per-type middlewares,
      // so an earlier keystroke may already have one scheduled.
      if (selectHasRun(store.getState())) {
        setCoordinateFieldValues.cancel();
        return;
      }
      setCoordinateFieldValues(store, form);
    }
  }
};

export default geocodeOnAddressChange;
